module.exports = __webpack_public_path__ + "static/media/GA-Resume.faf93c2b.pdf";